var exports = {
  "a": "Box__nCeqF8",
  "Y": "StyledTableCell__Gk3Iso",
};

module.exports = exports;
